import { array, partial } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { RoofId, FloorId, FrameId, EwpId, WholeHouseId } from './Id';

export const StructuredIds = partial({
	roof: array(RoofId),
	floor: array(FloorId),
	frame: array(FrameId),
	ewp: array(EwpId),
	wholeHouse: array(WholeHouseId),

	subFloor: iotsUtils.neverDecoder,
	firstFloor: iotsUtils.neverDecoder,
	secondFloor: iotsUtils.neverDecoder,
	flooring: iotsUtils.neverDecoder,
	bor: iotsUtils.neverDecoder,
	lintel: iotsUtils.neverDecoder,
	rafters: iotsUtils.neverDecoder,
	stickFraming: iotsUtils.neverDecoder,
	maxiwall: iotsUtils.neverDecoder,
	maxifloor: iotsUtils.neverDecoder,
	trimJoist: iotsUtils.neverDecoder,
	cassette: iotsUtils.neverDecoder,
});
